import { render, staticRenderFns } from "./DocCatTable.vue?vue&type=template&id=202c2846"
import script from "./DocCatTable.vue?vue&type=script&lang=js"
export * from "./DocCatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports